var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { InfoOutlined } from '@mui/icons-material';
import { createFilterOptions, SvgIcon } from '@mui/material';
import dayjs from 'dayjs';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { StatusEnum } from '../../../constants';
import { showSurface } from '../../../redux/awaitedSurfacesSlice';
import { showError } from '../../../redux/commonSlice';
import { setReducerState } from '../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { REG } from '../../../utils/validationHelper';
import TaxDetailsPopup from '../../jobCard/partGridPopups/taxDetailsPopup';
import { getServiceTypeList, getTax, getTechnicianList, getWorkDistributionStatusList, pauseReasonListAPICall } from '../services/apiCalls';
import { GridValidations, JobCardKeys } from '../services/entity';
import { handleRatioDetailsPopup } from './utils';
import { useState } from 'react';
export function useLabourElements() {
    var _this = this;
    var _crud$documentDetails2;
    var dispatch = useAppDispatch();
    var crud = useAppSelector(function (state) { return state.crud; });
    var _a = useState(), selectedStatus = _a[0], setSelectedStatus = _a[1];
    var labourElements = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            padding: '10px',
            rowSpacing: 2,
            columnSpacing: 2,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'Description',
                    label: 'Description :',
                    minRows: 4,
                    value: null,
                    disabled: true,
                    multiline: true,
                    xs: 12
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'HSNSACCode',
                    label: 'SAC Code :',
                    xs: 12,
                    disabled: true
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'Rate',
                    label: 'Rate',
                    value: null,
                    xs: 6,
                    valueGetter: function (formValues, field) {
                        var _formValues$SavedPric;
                        return formValues === null || formValues === void 0 || (_formValues$SavedPric = formValues.SavedPriceWithTax) === null || _formValues$SavedPric === void 0 ? void 0 : _formValues$SavedPric.Rate;
                    },
                    validator: function (value, updates) {
                        if (value != 0 && !value) {
                            return "This field is required";
                        }
                        if (updates !== null && updates !== void 0 && updates.MaxPrice && value > (updates === null || updates === void 0 ? void 0 : updates.MaxPrice)) {
                            return "Rate should be less than ".concat(updates === null || updates === void 0 ? void 0 : updates.MaxPrice);
                        }
                        if (updates !== null && updates !== void 0 && updates.OriginalPrice && value > (updates === null || updates === void 0 ? void 0 : updates.OriginalPrice)) {
                            return "Rate can not be greater than ".concat(updates === null || updates === void 0 ? void 0 : updates.OriginalPrice);
                        }
                        if (updates !== null && updates !== void 0 && updates.MinPrice && value < (updates === null || updates === void 0 ? void 0 : updates.MinPrice)) {
                            return "Rate should be more than ".concat(updates === null || updates === void 0 ? void 0 : updates.MinPrice);
                        }
                        if (!REG.validateDecimalAndNonNumeric.test(value) && value !== "") {
                            return "Up to 2 decimal precision is allowed";
                        }
                        return "";
                    },
                    setFieldProps: function (state, currValue, field) {
                        var _crud$documentDetails, _state$SavedPriceWith, _state$SavedPriceWith2;
                        var isDisabledBasedOnStatus = [StatusEnum.Delivered, StatusEnum.Cancelled, StatusEnum.ReadyForInvoice, StatusEnum.Awaiting, StatusEnum.Invoiced, StatusEnum.FinalInspection].includes((crud === null || crud === void 0 || (_crud$documentDetails = crud.documentDetailsGetById) === null || _crud$documentDetails === void 0 || (_crud$documentDetails = _crud$documentDetails.data) === null || _crud$documentDetails === void 0 ? void 0 : _crud$documentDetails.Key) || "");
                        var isRateEditable = typeof ((state === null || state === void 0 ? void 0 : state.SavedPriceWithTax) && (state === null || state === void 0 || (_state$SavedPriceWith = state.SavedPriceWithTax) === null || _state$SavedPriceWith === void 0 ? void 0 : _state$SavedPriceWith.IsRateEditable)) === 'boolean' ? state === null || state === void 0 || (_state$SavedPriceWith2 = state.SavedPriceWithTax) === null || _state$SavedPriceWith2 === void 0 ? void 0 : _state$SavedPriceWith2.IsRateEditable : false;
                        var isRateDisable = !isRateEditable;
                        return {
                            type: FormItemTypes.NumberInput,
                            disabled: isDisabledBasedOnStatus || isRateDisable
                        };
                    },
                    onFocus: function () {
                        dispatch(setReducerState({
                            key: JobCardKeys.DisableSubmit,
                            value: true
                        }));
                    },
                    onBlur: function (event, formValues, formApi) {
                        return __awaiter(this, void 0, void 0, function () {
                            var _formValues$IssuedQua, _formValues$CancelQua, _newPrice$payload, _newPrice$payload2, newPrice, issuedQty, cancelQty, qty, pendingQty, _newPrice$payload3, _updatedPrice$Taxes, _updatedPrice$Taxes2, _updatedPrice$Taxes3, _formApi$handleInputC, updatedPrice_1, IGST_1, CGST_1, SGST_1, setFormState;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (Number(event.target.value) === 0) {
                                            formApi === null || formApi === void 0 || formApi.setErrors(function (prev) { return _objectSpread(_objectSpread({}, prev), {}, {
                                                Rate: "Rate can not be 0",
                                                IsError: true
                                            }); });
                                            event.target.focus();
                                            return [2 /*return*/];
                                        }
                                        return [4 /*yield*/, getTax(_objectSpread(_objectSpread({}, formValues), {}, {
                                                Rate: Number(event.target.value)
                                            }), crud === null || crud === void 0 ? void 0 : crud.documentDetailsGetById)];
                                    case 1:
                                        newPrice = _a.sent();
                                        issuedQty = (_formValues$IssuedQua = formValues === null || formValues === void 0 ? void 0 : formValues.IssuedQuantity) !== null && _formValues$IssuedQua !== void 0 ? _formValues$IssuedQua : 0;
                                        cancelQty = (_formValues$CancelQua = formValues === null || formValues === void 0 ? void 0 : formValues.CancelQuantity) !== null && _formValues$CancelQua !== void 0 ? _formValues$CancelQua : 0;
                                        qty = Number(event.target.value) - issuedQty;
                                        pendingQty = qty - cancelQty;
                                        if (newPrice !== null && newPrice !== void 0 && (_newPrice$payload = newPrice.payload) !== null && _newPrice$payload !== void 0 && (_newPrice$payload = _newPrice$payload.value) !== null && _newPrice$payload !== void 0 && _newPrice$payload.data && newPrice !== null && newPrice !== void 0 && (_newPrice$payload2 = newPrice.payload) !== null && _newPrice$payload2 !== void 0 && (_newPrice$payload2 = _newPrice$payload2.value) !== null && _newPrice$payload2 !== void 0 && _newPrice$payload2.success) {
                                            updatedPrice_1 = newPrice === null || newPrice === void 0 || (_newPrice$payload3 = newPrice.payload) === null || _newPrice$payload3 === void 0 || (_newPrice$payload3 = _newPrice$payload3.value) === null || _newPrice$payload3 === void 0 ? void 0 : _newPrice$payload3.data;
                                            IGST_1 = updatedPrice_1 === null || updatedPrice_1 === void 0 || (_updatedPrice$Taxes = updatedPrice_1.Taxes) === null || _updatedPrice$Taxes === void 0 ? void 0 : _updatedPrice$Taxes.find(function (item) { return item.TaxComponentName === "IGST"; });
                                            CGST_1 = updatedPrice_1 === null || updatedPrice_1 === void 0 || (_updatedPrice$Taxes2 = updatedPrice_1.Taxes) === null || _updatedPrice$Taxes2 === void 0 ? void 0 : _updatedPrice$Taxes2.find(function (item) { return item.TaxComponentName === "CGST"; });
                                            SGST_1 = updatedPrice_1 === null || updatedPrice_1 === void 0 || (_updatedPrice$Taxes3 = updatedPrice_1.Taxes) === null || _updatedPrice$Taxes3 === void 0 ? void 0 : _updatedPrice$Taxes3.find(function (item) { return item.TaxComponentName === "SGST"; });
                                            setFormState = function (state) {
                                                var _state$SavedPriceWith3;
                                                return {
                                                    IsPriceUpdate: true,
                                                    SavedPriceWithTax: _objectSpread(_objectSpread({}, state.SavedPriceWithTax), {}, {
                                                        "Taxes": updatedPrice_1.Taxes,
                                                        "Rate": updatedPrice_1.Rate,
                                                        "Quantity": updatedPrice_1.Quantity,
                                                        "Amount": updatedPrice_1.Amount,
                                                        "TaxableAmount": updatedPrice_1.TaxableAmount,
                                                        "BaseAmount": updatedPrice_1.BaseAmount
                                                    }),
                                                    MRP: updatedPrice_1 === null || updatedPrice_1 === void 0 ? void 0 : updatedPrice_1.MRP,
                                                    TaxableAmount: updatedPrice_1 === null || updatedPrice_1 === void 0 ? void 0 : updatedPrice_1.TaxableAmount,
                                                    Amount: updatedPrice_1 === null || updatedPrice_1 === void 0 ? void 0 : updatedPrice_1.Amount,
                                                    Rate: updatedPrice_1 === null || updatedPrice_1 === void 0 ? void 0 : updatedPrice_1.Rate,
                                                    SGST_UTGST_Amount: SGST_1 ? SGST_1 === null || SGST_1 === void 0 ? void 0 : SGST_1.TaxComponentAmount : 0,
                                                    SGST_UTGST_Percentage: SGST_1 ? SGST_1 === null || SGST_1 === void 0 ? void 0 : SGST_1.TaxComponentPercentage : 0,
                                                    CGSTAmount: CGST_1 ? CGST_1.TaxComponentAmount : 0,
                                                    CGSTPercentage: CGST_1 ? CGST_1.TaxComponentPercentage : 0,
                                                    IGSTAmount: IGST_1 ? IGST_1 === null || IGST_1 === void 0 ? void 0 : IGST_1.TaxComponentAmount : 0,
                                                    IGSTPercentage: IGST_1 ? IGST_1.TaxComponentPercentage : 0,
                                                    PriceGroupCategoryKey: updatedPrice_1.PriceGroupCategoryKey || (state === null || state === void 0 || (_state$SavedPriceWith3 = state.SavedPriceWithTax) === null || _state$SavedPriceWith3 === void 0 ? void 0 : _state$SavedPriceWith3.PriceGroupCategoryKey),
                                                    PendingQuantity: pendingQty >= 0 ? pendingQty : 0,
                                                    error: undefined
                                                };
                                            };
                                            formApi === null || formApi === void 0 || (_formApi$handleInputC = formApi.handleInputChange) === null || _formApi$handleInputC === void 0 || _formApi$handleInputC.call(formApi, event, event.target.value, _objectSpread(_objectSpread({}, this), {}, {
                                                setFormState: setFormState
                                            }));
                                            formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                                return _objectSpread(_objectSpread({}, prev), {}, {
                                                    IsError: false,
                                                    Rate: ""
                                                });
                                            });
                                        }
                                        else {
                                            formApi === null || formApi === void 0 || formApi.setErrors(function (prev) {
                                                var _newPrice$payload4;
                                                return _objectSpread(_objectSpread({}, prev), {}, {
                                                    Rate: (newPrice === null || newPrice === void 0 || (_newPrice$payload4 = newPrice.payload) === null || _newPrice$payload4 === void 0 || (_newPrice$payload4 = _newPrice$payload4.value) === null || _newPrice$payload4 === void 0 ? void 0 : _newPrice$payload4.message) || "Something went wrong",
                                                    IsError: true
                                                });
                                            });
                                            event.target.focus();
                                        }
                                        dispatch(setReducerState({
                                            key: JobCardKeys.DisableSubmit,
                                            value: false
                                        }));
                                        return [2 /*return*/];
                                }
                            });
                        });
                    }
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'Quantity',
                    label: 'Unit',
                    value: null,
                    xs: 6,
                    disabled: true,
                    setFormState: function (formValues, value) {
                        return {
                            Amount: (formValues === null || formValues === void 0 ? void 0 : formValues.Rate) * value,
                            TaxAmount: (formValues === null || formValues === void 0 ? void 0 : formValues.Rate) * value
                        };
                    }
                },
                // {
                //     type: FormItemTypes.SearchSelect,
                //     name: 'UnitOfMeasurementId',
                //     label: 'UOM',
                //     getListData: UnitOfMeasurementList,
                //     apiKey: 'UnitOfMeasurementList',
                //     displayExpr: 'Name',
                //     valueExpr: 'id',
                //     xs: 12,
                //     disabled: true
                // },
                {
                    type: FormItemTypes.SearchSelect,
                    name: 'ServiceTypeId',
                    label: 'Service type',
                    getListData: getServiceTypeList,
                    apiKey: 'serviceTypeList',
                    displayExpr: 'DisplayName',
                    valueExpr: 'id',
                    xs: 12,
                    disabled: true
                    // required: true
                }, {
                    type: FormItemTypes.SearchSelect,
                    label: 'Technician',
                    name: 'TechnicianId',
                    getOptionLabel: function (option) { return option !== null && option !== void 0 && option.FirstName || option !== null && option !== void 0 && option.LastName ? (option === null || option === void 0 ? void 0 : option.FirstName) + " " + (option === null || option === void 0 ? void 0 : option.LastName) : ''; },
                    validator: function (value, updates) {
                        var message = '';
                        if (!value) {
                            if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Started) {
                                return "You cannont clear 'Technician Name' since status is started.";
                            }
                            if (updates !== null && updates !== void 0 && updates.TechnicianId && (updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Completed) {
                                return GridValidations.WORK_COMPLETED;
                            }
                            if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Pause) {
                                return GridValidations.LABOUR_PAUSED;
                            }
                            return message;
                        }
                        // if (value === updates?.TechnicianId) return message;
                        switch (updates === null || updates === void 0 ? void 0 : updates.StatusName) {
                            // case StatusEnum.Completed:
                            //     message = GridValidations.WORK_COMPLETED;
                            //     break;
                            // case StatusEnum.Pause:
                            //     message = GridValidations.LABOUR_PAUSED;
                            //     break;
                            default:
                                if (!(updates !== null && updates !== void 0 && updates.HSNSACCode))
                                    message = GridValidations.SAC_REQUIRED;
                                break;
                        }
                        return message;
                    },
                    valueSetter: function (formValue, currValue) {
                        var _currValue$id;
                        if (formValue !== null && formValue !== void 0 && formValue.TechnicianId && (formValue === null || formValue === void 0 ? void 0 : formValue.StatusName) === StatusEnum.Completed) {
                            dispatch(showError(GridValidations.WORK_COMPLETED));
                            return {
                                TechnicianName: formValue === null || formValue === void 0 ? void 0 : formValue.TechnicianName,
                                TechnicianId: formValue === null || formValue === void 0 ? void 0 : formValue.TechnicianId,
                                TechnicianFamilyName: formValue === null || formValue === void 0 ? void 0 : formValue.TechnicianFamilyName
                            };
                        }
                        if ((formValue === null || formValue === void 0 ? void 0 : formValue.StatusName) === StatusEnum.Pause) {
                            dispatch(showError(GridValidations.LABOUR_PAUSED));
                            return {
                                TechnicianName: formValue === null || formValue === void 0 ? void 0 : formValue.TechnicianName,
                                TechnicianId: formValue === null || formValue === void 0 ? void 0 : formValue.TechnicianId,
                                TechnicianFamilyName: formValue === null || formValue === void 0 ? void 0 : formValue.TechnicianFamilyName
                            };
                        }
                        if (!formValue) {
                            return _objectSpread(_objectSpread({}, formValue), {}, {
                                ServiceStartDateTime: null,
                                ServiceEndDateTime: null,
                                TechnicianName: null,
                                TechnicianId: null,
                                TechnicianFamilyName: null
                            });
                        }
                        return _objectSpread(_objectSpread({}, formValue), {}, {
                            TechnicianName: currValue === null || currValue === void 0 ? void 0 : currValue.FirstName,
                            TechnicianFamilyName: currValue === null || currValue === void 0 ? void 0 : currValue.LastName,
                            TechnicianId: (_currValue$id = currValue === null || currValue === void 0 ? void 0 : currValue.id) !== null && _currValue$id !== void 0 ? _currValue$id : null
                        });
                    },
                    // options: technicianList ?? [],
                    getListData: getTechnicianList,
                    apiKey: 'technicianList',
                    apiRequest: {
                        WorkingOrganizationId: crud === null || crud === void 0 || (_crud$documentDetails2 = crud.documentDetailsGetById) === null || _crud$documentDetails2 === void 0 || (_crud$documentDetails2 = _crud$documentDetails2.data) === null || _crud$documentDetails2 === void 0 ? void 0 : _crud$documentDetails2.OrganizationId
                    },
                    valueExpr: 'id',
                    displayExpr: 'FirstName'
                },
                // {
                //     type: FormItemTypes.NumberInput,
                //     name: 'Requestedqty',
                //     label: 'Requested qty',
                //     value: null,
                //     xs: 6,
                //     setFieldProps: (state) => ({
                //         type: FormItemTypes.NumberInput,
                //     })
                // },
                {
                    type: FormItemTypes.DateTimePicker,
                    name: 'ServiceStartDateTime',
                    label: 'Start date & time:',
                    value: null,
                    xs: 12,
                    valueSetter: function (formValue, currValue) {
                        switch (formValue === null || formValue === void 0 ? void 0 : formValue.StatusName) {
                            case StatusEnum.Completed:
                                dispatch(showError(GridValidations.WORK_COMPLETED));
                                return {
                                    ServiceStartDateTime: formValue === null || formValue === void 0 ? void 0 : formValue.ServiceStartDateTime
                                };
                            case StatusEnum.Pause:
                                dispatch(showError(GridValidations.LABOUR_PAUSED));
                                return {
                                    ServiceStartDateTime: formValue === null || formValue === void 0 ? void 0 : formValue.ServiceStartDateTime
                                };
                            case StatusEnum.Awaiting:
                                dispatch(showError(GridValidations.LABOUR_AWAITING));
                                return {
                                    ServiceStartDateTime: null
                                };
                        }
                    },
                    validator: function (value, updates) {
                        var _dayjs, _dayjs2;
                        var message = '';
                        var previousStartDate = dayjs(updates === null || updates === void 0 ? void 0 : updates.ServiceStartDateTime);
                        var currStartDate = dayjs(value);
                        if (!value) {
                            if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Start) {
                                return "You cannot clear the 'Date and time' since work is already started.";
                            }
                            if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Pause) {
                                return "You cannot clear the 'Date and time' since work is paused.";
                            }
                            if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Completed) {
                                return "You cannot clear the 'Date and time' since work is completed.";
                            }
                            return message;
                        }
                        // if (!updates?.HSNSACCode)
                        //     message = GridValidations.SAC_REQUIRED;
                        // if (updates?.JCCreationDate && dayjs(value)?.isBefore(dayjs(updates?.JCCreationDate)))
                        //     message = "Start date time should be greater than document creation date time.";
                        // if ((dayjs(value).isAfter(dayjs())))
                        //     message = "Labor start date time can not be greater than actual date time.";
                        switch (updates === null || updates === void 0 ? void 0 : updates.StatusName) {
                            case StatusEnum.Completed:
                                if (currStartDate !== null && currStartDate !== void 0 && currStartDate.isSame(previousStartDate, 'minute')) {
                                    return message;
                                }
                                message = "You cannot change the 'Date and time' since work is completed. ( Start time: ".concat(previousStartDate && (previousStartDate === null || previousStartDate === void 0 ? void 0 : previousStartDate.format('DD MMM, YYYY h:mm A')), " )");
                                break;
                            case StatusEnum.Pause:
                                if (currStartDate !== null && currStartDate !== void 0 && currStartDate.isSame(previousStartDate, 'minute')) {
                                    return message;
                                }
                                message = "You cannot change the 'Date and time' since work is paused. ( Start time: ".concat(previousStartDate && (previousStartDate === null || previousStartDate === void 0 ? void 0 : previousStartDate.format('DD MMM, YYYY h:mm A')), " )");
                                break;
                            case StatusEnum.Awaiting:
                                message = GridValidations.LABOUR_AWAITING;
                                break;
                            default:
                                if (!(updates !== null && updates !== void 0 && updates.HSNSACCode))
                                    message = GridValidations.SAC_REQUIRED;
                                if ((_dayjs = dayjs(value)) !== null && _dayjs !== void 0 && _dayjs.isAfter(dayjs(updates === null || updates === void 0 ? void 0 : updates.JCCreationDate))) {
                                    return message;
                                }
                                if (updates !== null && updates !== void 0 && updates.JCCreationDate && (_dayjs2 = dayjs(value)) !== null && _dayjs2 !== void 0 && _dayjs2.isBefore(dayjs(updates === null || updates === void 0 ? void 0 : updates.JCCreationDate)))
                                    message = "Start date time should be greater than document creation date time.";
                                if (dayjs(value).isAfter(dayjs()))
                                    message = "Labor start date time can not be greater than actual date time.";
                                break;
                        }
                        return message;
                    },
                    disableFuture: true,
                    setFieldProps: function (formValues) {
                        return {
                            disabled: (formValues === null || formValues === void 0 ? void 0 : formValues.StatusName) === StatusEnum.Awaiting,
                            maxDateTime: formValues !== null && formValues !== void 0 && formValues.ServiceEndDateTime ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.ServiceEndDateTime) : undefined,
                            clearable: !((formValues === null || formValues === void 0 ? void 0 : formValues.StatusName) === StatusEnum.Completed || (formValues === null || formValues === void 0 ? void 0 : formValues.StatusName) === StatusEnum.Pause)
                        };
                    }
                }, {
                    type: FormItemTypes.DateTimePicker,
                    name: 'ServiceEndDateTime',
                    label: 'End date & time:',
                    value: null,
                    xs: 12,
                    valueSetter: function (formValue, currValue) {
                        switch (formValue === null || formValue === void 0 ? void 0 : formValue.StatusName) {
                            case StatusEnum.Completed:
                                dispatch(showError(GridValidations.WORK_COMPLETED));
                                return _objectSpread(_objectSpread({}, formValue), {}, {
                                    ServiceEndDateTime: formValue === null || formValue === void 0 ? void 0 : formValue.ServiceEndDateTime
                                });
                            case StatusEnum.Pause:
                                dispatch(showError(GridValidations.LABOUR_PAUSED));
                                return {
                                    ServiceEndDateTime: formValue === null || formValue === void 0 ? void 0 : formValue.ServiceEndDateTime
                                };
                            case StatusEnum.Awaiting:
                                dispatch(showError(GridValidations.LABOUR_AWAITING));
                                return {
                                    ServiceEndDateTime: formValue === null || formValue === void 0 ? void 0 : formValue.ServiceEndDateTime
                                };
                        }
                    },
                    setFieldProps: function (formValues) {
                        return {
                            minDateTime: dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.ServiceStartDateTime),
                            disabled: (formValues === null || formValues === void 0 ? void 0 : formValues.StatusName) === StatusEnum.Awaiting,
                            clearable: !((formValues === null || formValues === void 0 ? void 0 : formValues.StatusName) === StatusEnum.Completed || (formValues === null || formValues === void 0 ? void 0 : formValues.StatusName) === StatusEnum.Pause)
                        };
                    },
                    validator: function (value, updates) {
                        var _dayjs3;
                        var message = '';
                        var previousEndDate = dayjs(updates === null || updates === void 0 ? void 0 : updates.ServiceEndDateTime);
                        var currEndDate = dayjs(value);
                        if (!value) {
                            if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Pause) {
                                return "You cannot clear the 'Date and time' since work is paused.";
                            }
                            if ((updates === null || updates === void 0 ? void 0 : updates.StatusName) === StatusEnum.Completed) {
                                return "You cannot clear the 'Date and time' since work is completed.";
                            }
                            return message;
                        }
                        switch (updates === null || updates === void 0 ? void 0 : updates.StatusName) {
                            case StatusEnum.Completed:
                                if (currEndDate !== null && currEndDate !== void 0 && currEndDate.isSame(previousEndDate, 'minute')) {
                                    return message;
                                }
                                message = "You cannot change the 'Date and time' since work is completed. ( End time: ".concat(previousEndDate && (previousEndDate === null || previousEndDate === void 0 ? void 0 : previousEndDate.format('DD MMM, YYYY h:mm A')), " )");
                                break;
                            case StatusEnum.Pause:
                                if (currEndDate !== null && currEndDate !== void 0 && currEndDate.isSame(previousEndDate, 'minute')) {
                                    return message;
                                }
                                message = "You cannot change the 'Date and time' since work is paused. ( End time: ".concat(previousEndDate && (previousEndDate === null || previousEndDate === void 0 ? void 0 : previousEndDate.format('DD MMM, YYYY h:mm A')), " )");
                                break;
                            case StatusEnum.Awaiting:
                                message = GridValidations.LABOUR_AWAITING;
                                break;
                            case StatusEnum.Start:
                                message = GridValidations.DATE_VALIDATION;
                                break;
                            default:
                                if (!(updates !== null && updates !== void 0 && updates.HSNSACCode))
                                    message = GridValidations.SAC_REQUIRED;
                                if ((_dayjs3 = dayjs(value)) !== null && _dayjs3 !== void 0 && _dayjs3.isBefore(dayjs(updates === null || updates === void 0 ? void 0 : updates.ServiceStartDateTime), 'minute')) {
                                    message = "End date time cannot be earlier than start date time";
                                }
                                else if (dayjs(value).isAfter(dayjs(), 'minute') && !dayjs(value).isSame(dayjs(), 'day')) {
                                    message = "Post dated transaction not allowed";
                                }
                                break;
                        }
                        return message;
                    }
                },
                //2.5.1
                // {
                //     type: FormItemTypes.TextInput,
                //     name: 'TradeDiscountPercentage',
                //     label: 'Trade Discount ',
                //     disabled: true,
                //     value: null,
                //     xs: 4,
                // },
                // {
                //     type: FormItemTypes.TextInput,
                //     name: 'TradeDiscountAmount',
                //     label: '',
                //     disabled: true,
                //     value: null,
                //     xs: 8,
                //     sx: {
                //         mt: '20px'
                //     }
                // },
                {
                    type: FormItemTypes.NumberInput,
                    name: 'TaxableAmount',
                    label: 'Taxable amount (₹) ',
                    value: null,
                    xs: 6,
                    disabled: true
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 6,
                    elements: [{
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            justifyContent: 'space-between',
                            columnSize: 12,
                            alignItems: 'center',
                            mb: 0.5,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    children: 'Total taxes (₹)',
                                    columnSize: 0,
                                    fontSize: 'sm',
                                    color: 'text.secondary',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.IconButton,
                                    name: '',
                                    children: /*#__PURE__*/ React.createElement(SvgIcon, {
                                        color: "primary",
                                        sx: {
                                            height: 20,
                                            width: 20
                                        }
                                    }, /*#__PURE__*/ React.createElement(InfoOutlined, null)),
                                    columnSize: 0,
                                    sx: {
                                        p: 0
                                    },
                                    setFieldProps: function () {
                                        return {
                                            disabled: false
                                        };
                                    },
                                    onClick: function (e, state) { return __awaiter(_this, void 0, void 0, function () {
                                        return __generator(this, function (_a) {
                                            dispatch(showSurface({
                                                type: 'Drawer',
                                                Component: TaxDetailsPopup,
                                                containerProps: {
                                                    PaperProps: {
                                                        sx: {
                                                            px: 0.5,
                                                            width: {
                                                                xs: '100%'
                                                            },
                                                            borderRadius: '8px 8px 0 0'
                                                        }
                                                    },
                                                    anchor: 'bottom'
                                                },
                                                componentProps: {
                                                    data: state
                                                }
                                            }));
                                            return [2 /*return*/];
                                        });
                                    }); },
                                    unsubscribeFormChange: true
                                }]
                        }, {
                            type: FormItemTypes.NumberInput,
                            name: 'Totaltaxes',
                            label: '',
                            columnSize: 0,
                            disabled: true,
                            sx: {
                                p: 0
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$SavedPric2;
                                var totalTax = 0;
                                formValues === null || formValues === void 0 || (_formValues$SavedPric2 = formValues.SavedPriceWithTax) === null || _formValues$SavedPric2 === void 0 || (_formValues$SavedPric2 = _formValues$SavedPric2.Taxes) === null || _formValues$SavedPric2 === void 0 || _formValues$SavedPric2.forEach(function (taxItem) {
                                    totalTax += taxItem.TaxComponentAmount;
                                });
                                var displayValue = totalTax > 0 ? totalTax.toFixed(2) : 0;
                                return displayValue;
                            }
                        }]
                }, {
                    type: FormItemTypes.Box,
                    name: '',
                    // display: 'flex',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Box,
                            name: '',
                            display: 'flex',
                            justifyContent: 'space-between',
                            columnSize: 12,
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: '',
                                    value: 'Amount (₹)',
                                    columnSize: 0,
                                    color: 'text.secondary',
                                    fontSize: 'sm',
                                    fontWeight: 'medium'
                                }, {
                                    type: FormItemTypes.Button,
                                    name: '',
                                    variant: 'text',
                                    children: 'Ratio',
                                    columnSize: 0,
                                    sx: {
                                        pt: 0
                                    },
                                    onClick: function (e, formValues, api) {
                                        var _crud$documentDetails3;
                                        handleRatioDetailsPopup(formValues, crud === null || crud === void 0 || (_crud$documentDetails3 = crud.documentDetailsGetById) === null || _crud$documentDetails3 === void 0 || (_crud$documentDetails3 = _crud$documentDetails3.data) === null || _crud$documentDetails3 === void 0 ? void 0 : _crud$documentDetails3.RepairTypeId);
                                    },
                                    setFieldProps: function (formValues, currValue) {
                                        var _formValues$RatioBill;
                                        return {
                                            disabled: false,
                                            sx: {
                                                display: ((_formValues$RatioBill = formValues.RatioBilling) === null || _formValues$RatioBill === void 0 ? void 0 : _formValues$RatioBill.length) > 0 ? 'inline-flex' : 'none',
                                                pt: 0
                                            }
                                        };
                                    }
                                }]
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'Amount',
                            label: '',
                            value: null,
                            xs: 12,
                            disabled: true
                        }]
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'PauseReasonId',
                    label: 'Pause Reason',
                    getListData: pauseReasonListAPICall,
                    apiRequest: {
                        SystemName: "JobCardDetail"
                    },
                    apiKey: 'PauseReasonData',
                    displayExpr: 'Name',
                    valueExpr: 'id',
                    xs: 12,
                    setFieldProps: function (formValues) {
                        return {
                            disabled: (formValues === null || formValues === void 0 ? void 0 : formValues.StatusName) !== StatusEnum.Pause
                        };
                    },
                    validator: function (value, state) {
                        var message = '';
                        if (!value)
                            return message;
                        switch (state === null || state === void 0 ? void 0 : state.StatusName) {
                            case StatusEnum.Pause:
                                if (!value)
                                    return "You cannont leave 'Pause Reason' blank since it is mandatory.";
                                break;
                            default:
                                if (value)
                                    return "You cannot set 'Pause Reason' as status is not pause.";
                                break;
                        }
                        return message;
                    }
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'PauseRemarks',
                    label: 'Pause Remarks',
                    minRows: 3,
                    value: null,
                    multiline: true,
                    xs: 12,
                    setFieldProps: function (formValues, currValue, field) {
                        return {
                            disabled: (formValues === null || formValues === void 0 ? void 0 : formValues.StatusName) !== StatusEnum.Pause
                        };
                    },
                    validator: function (value, state) {
                        var message = '';
                        if (!value)
                            return message;
                        switch (state === null || state === void 0 ? void 0 : state.StatusName) {
                            case StatusEnum.Pause:
                                if (!value)
                                    return "You cannont leave 'Pause remark' blank since it is mandatory.";
                                if ((value === null || value === void 0 ? void 0 : value.length) > 200) {
                                    return "Maximum allowed limit is 200";
                                }
                                else {
                                    return '';
                                }
                            default:
                                if (value)
                                    return "You cannot set 'Pause Remark' as status is not pause.";
                                break;
                        }
                        return message;
                    }
                },
                // {
                //     type: FormItemTypes.TextInput,
                //     name: 'Remarks',
                //     label: 'Remark :',
                //     minRows: 3,
                //     value: null,
                //     multiline: true,
                //     xs: 12,
                // },
                // {
                //     type: FormItemTypes.NumberInput,
                //     name: 'Price',
                //     label: 'Amount',
                //     value: null,
                //     xs: 12,
                // },
                {
                    type: FormItemTypes.SearchSelect,
                    name: 'StatusId',
                    label: 'Status',
                    setFieldProps: function (formValues, currValue, field, formApi) {
                        return {
                            filterOptions: function (options, filterState) {
                                var filteredOptions = createFilterOptions()(options, filterState);
                                return filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.filter(function (it) { return (it === null || it === void 0 ? void 0 : it.StatusId) !== (formValues === null || formValues === void 0 ? void 0 : formValues.StatusId); });
                            }
                        };
                    },
                    validator: function (value, state) {
                        var message = '';
                        if (!value)
                            return "You cannont leave 'Status' blank since it is mandatory.";
                        else if ((state === null || state === void 0 ? void 0 : state.StatusName) === StatusEnum.Awaiting) {
                            message = '';
                        }
                        else if (!(state !== null && state !== void 0 && state.HSNSACCode)) {
                            message = GridValidations.SAC_REQUIRED;
                        }
                        else if (!(state !== null && state !== void 0 && state.TechnicianId) && (state === null || state === void 0 ? void 0 : state.StatusName) !== StatusEnum.Awaiting) {
                            message = GridValidations.MECHANIC_NOT_ALLOCATED;
                        }
                        else if (!(state !== null && state !== void 0 && state.ServiceTypeName) && (state === null || state === void 0 ? void 0 : state.StatusName) !== StatusEnum.Awaiting) {
                            message = GridValidations.JOB_TYPE_REQUIRED;
                        }
                        return message;
                    },
                    // apiKey: JobCardKeys.LabourStatusList,
                    displayExpr: 'Name',
                    valueExpr: 'id',
                    getListData: getWorkDistributionStatusList,
                    apiRequest: {
                        SystemName: 'JobCardDetail'
                    },
                    setFormState: function (formValues, currValue, field) {
                        if (!(formValues !== null && formValues !== void 0 && formValues.TechnicianId)) {
                            dispatch(showError(GridValidations.MECHANIC_NOT_ALLOCATED));
                            return {
                                formValues: formValues
                            };
                        }
                    },
                    valueSetter: function (formValues, currValues) {
                        var _currValues$DisplayNa, _currValues$id;
                        setSelectedStatus(formValues);
                        if (!(formValues !== null && formValues !== void 0 && formValues.TechnicianId)) {
                            return {
                                formValues: formValues
                            };
                        }
                        var serviceStartDateTime;
                        var serviceEndDateTime;
                        var newStatus = currValues === null || currValues === void 0 ? void 0 : currValues.DisplayName;
                        var prevStatus = formValues === null || formValues === void 0 ? void 0 : formValues.StatusName;
                        var isCompleted = newStatus === StatusEnum.Completed;
                        var isPaused = newStatus === StatusEnum.Pause;
                        var isAwaiting = newStatus === StatusEnum.Awaiting;
                        var wasCompleted = prevStatus === StatusEnum.Completed;
                        var wasPaused = prevStatus === StatusEnum.Pause;
                        var wasStart = prevStatus === StatusEnum.Start;
                        var hasStartTime = !!(formValues !== null && formValues !== void 0 && formValues.ServiceStartDateTime);
                        var hasEndTime = !!(formValues !== null && formValues !== void 0 && formValues.ServiceEndDateTime);
                        if (newStatus === StatusEnum.Start) {
                            serviceStartDateTime = new Date();
                            serviceEndDateTime = null;
                        }
                        else if ((isCompleted || isPaused) && !hasStartTime) {
                            serviceStartDateTime = new Date();
                            serviceEndDateTime = new Date();
                        }
                        else if (isAwaiting) {
                            serviceStartDateTime = null;
                            serviceEndDateTime = null;
                        }
                        else {
                            serviceStartDateTime = formValues === null || formValues === void 0 ? void 0 : formValues.ServiceStartDateTime;
                            if (isCompleted && !hasEndTime || wasCompleted && isPaused || wasPaused && isCompleted || wasStart && isPaused) {
                                serviceEndDateTime = new Date();
                            }
                            else {
                                var _formValues$ServiceEn;
                                serviceEndDateTime = (_formValues$ServiceEn = formValues === null || formValues === void 0 ? void 0 : formValues.ServiceEndDateTime) !== null && _formValues$ServiceEn !== void 0 ? _formValues$ServiceEn : null;
                            }
                        }
                        return _objectSpread(_objectSpread({}, formValues), {}, {
                            StatusName: (_currValues$DisplayNa = currValues === null || currValues === void 0 ? void 0 : currValues.DisplayName) !== null && _currValues$DisplayNa !== void 0 ? _currValues$DisplayNa : '',
                            StatusId: (_currValues$id = currValues === null || currValues === void 0 ? void 0 : currValues.id) !== null && _currValues$id !== void 0 ? _currValues$id : null,
                            PauseReasonName: (currValues === null || currValues === void 0 ? void 0 : currValues.DisplayName) !== StatusEnum.Pause ? null : formValues === null || formValues === void 0 ? void 0 : formValues.PauseReasonName,
                            PauseReasonId: (currValues === null || currValues === void 0 ? void 0 : currValues.DisplayName) !== StatusEnum.Pause ? null : formValues === null || formValues === void 0 ? void 0 : formValues.PauseReasonId,
                            PauseRemarks: (currValues === null || currValues === void 0 ? void 0 : currValues.DisplayName) !== StatusEnum.Pause ? null : formValues === null || formValues === void 0 ? void 0 : formValues.PauseRemarks,
                            StatusKey: currValues === null || currValues === void 0 ? void 0 : currValues.DisplayName,
                            ServiceStartDateTime: serviceStartDateTime,
                            ServiceEndDateTime: serviceEndDateTime
                        });
                    },
                    value: null,
                    xs: 12
                }
                //2.5.1
                // {
                //     type: FormItemTypes.Box,
                //     name: '',
                //     display: 'flex',
                //     justifyContent: 'end',
                //     gap: '16px',
                //     columnSize: 12,
                //     elements: [
                //         {
                //             type: FormItemTypes.Button,
                //             name: '',
                //             variant: 'outlined',
                //             children: 'View more',
                //             columnSize: 0,
                //             setFormState: async (state) => {
                //                 const res = await dispatch(showSurface({
                //                     type: 'Drawer',
                //                     Component: LabourMoreDetailsPopup,
                //                     containerProps: {
                //                         anchor: 'bottom',
                //                         PaperProps: {
                //                             sx: {
                //                                 borderRadius: '8px 8px 0 0'
                //                             }
                //                         }
                //                     },
                //                     componentProps: {
                //                         data: state,
                //                         wpRequest: {
                //                             JobCardId: state?.JobCardId,
                //                             JobCardDetailId: state?.JobCardDetailId,
                //                         }
                //                     }
                //                 }));
                //                 if (res?.payload) {
                //                     return {
                //                         ...res?.payload
                //                     }
                //                 }
                //             }
                //         }],
                // },
            ]
        }];
    return labourElements;
}
